export default __webpack_public_path__ + "static/imgWarranty-775bb68a60395d18aaf1252afc25eac7.webp";